

//always start at the top of the page
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}
document.addEventListener("DOMContentLoaded", function() {
setTimeout(function() {
    window.scrollTo(0, 0);
  }, 0);
});



window.intro_loaded = false




$(function(){

    window.scrolltied = new ScrollTide({nomarkers: true});



    window.main_video = document.getElementById("box-video");

    if (window.anim_handle != false && !window.box_set) {
        setup_anim_canvas()
    }
    else {
        $("main").addClass("stage-1")
    }

    $(".main-title h1").addClass("visible")

    setup_scrollties()


    if (!window.box_set) {
        setup_feat_prod_swiper()
        setup_recipe_swiper()
        setup_mobile_stats_swiper()
        setup_stat_hovers()
    }


    setup_misc_click_handlers()
    
    
})





window.atc_clicks = 0
window.atc_error = false
function open_bottomless(){
    window.Bottomless.openWidgetModal(product.id, window.selected_variant.id, {
        variant_id:window.selected_variant.id,
        product_id:product.id,
        variant: window.selected_variant,
        product_title:"Test",
        selling_plan_id:"",
        frequency_num:"",
        quantity: "1",
        prepay: false,
        prepay_duration: 0,
        frequency_type_text:"Week(s)",
        meta:{}
    });
}
function setup_misc_click_handlers(){

    



    //ATC - desktop (non-subscribe)
    $(".atc-button.desktop-only").click(function(){


        var that = $(this)

        window.atc_clicks++

        var already_did = false
        if (that.html() == "Going..." || that.html() == "You did it!" || that.html() == "Again, again!!"){
            already_did = true
        }

        that.html("Going...")


        
        var id = window.selected_variant.id
        var qty = window.get_global_atc_quantity ? window.get_global_atc_quantity() : 1

        CartJS.addItem(id,qty, {}, {
            "success":function(line_item, msg){
                show_cart_confirm(line_item)
                $("header .cart-count").show()
                if (already_did){
                    if (window.atc_clicks > 3){
                        that.html("Hehe, it tickles... 🤮")
                    }
                    else {
                        that.html("Again, again!!")
                    }
                    
                }
                else {
                    that.html("You did it!")
                }
                
            },
            "error":function(e){
                if (window.atc_error){
                    that.html("Please call us...")
                    window.atc_error = false
                }
                else {
                    window.atc_error = true
                    that.html("Error! :(")
                }
                
                console.log(e)
                //alert("We weren't able to add t")
            }
        });


        //get qty
        //get variant id

        //SEND IT, BRUH
    })

    //ATC - mobile (dual mode both one-time and subscription)
    $(".atc-button.mobile-only").click(function(){
        


        var id = window.selected_variant.id
        var qty = window.get_global_atc_quantity ? window.get_global_atc_quantity() : 1



        var atc_options = {}
        var sub_id = $("#subscribe-selector-mobile").find(':selected').attr('data-id');

        var freq_num = $("#subscribe-selector-mobile").val()
        if (freq_num == "bottomless"){
            //show popup
            open_bottomless()
            return
        }
        if (freq_num != "one-time"){
            atc_options = {
                shipping_interval_frequency:freq_num,
                selling_plan:parseInt(sub_id)
            }
        }

        var that = $(this)
        that.html("Going...")


        CartJS.addItem(id,qty, atc_options, {
            "success":function(line_item){
            show_cart_confirm(line_item)
                $("header .cart-count").show()
                that.html("Added!")
            },
            "error":function(e){
                //console.log(e)
                that.html("Error :(")
            }
        });

    })

    $(".trans-learn-more").click(function(){
        $(".coffee-modal.active").removeClass("active")
        var this_id = $(this).attr("data-id")
        $("html").addClass("stuck")
        $("#" + this_id).addClass("active")
    })

    $(".trans-tab").click(function(){
        
        var active_tab = $(".trans-tab.active")
        var active_video = active_tab.find(".trans-img video")[0]
        if (active_video)
            active_video.pause()

        $(".trans-tab.active").removeClass("active")
        
        
        var new_video = $(this).find(".trans-img video")[0]
        $(this).addClass("active")

        //if (window.innerWidth < 800)
            //$(this)[0].scrollIntoView({ behavior: "smooth" }); 

        if (!new_video) return
        new_video.play()
        

    })


    $(".a-stat-desc .button").click(function(){
        $(".coffee-modal.active").removeClass("active")
        var this_id = $(this).attr("data-id")
        $("html").addClass("stuck")
        $("#" + this_id).addClass("active")
    })

    //subscribe click
    $(".subscribe-atc").click(function(){
        var that = $(this)
        that.html("One Sec...")

        var id = window.selected_variant.id
        var qty = window.get_global_atc_quantity ? window.get_global_atc_quantity() : 1

        var freq_num = $("#subscribe-selector").val()
        if (freq_num == "bottomless"){
            open_bottomless()
            //show popup
            return
        }

        var atc_options = {}
        var sub_id = $("#subscribe-selector").find(':selected').attr('data-id');
        

        atc_options = {
            shipping_interval_frequency:freq_num,
            selling_plan:parseInt(sub_id)
        }

        console.log(atc_options)

        CartJS.addItem(id,qty, atc_options, {
            "success":function(line_item){
            show_cart_confirm(line_item)
                $("header .cart-count").show()
            },
            "error":function(e){
                console.log(e)
                that.html("Error :(")
            }
        });

    })


    $(".bottomless-help").click(function(){
        open_bottomless()
    })

    //showing and hiding the story popup
    $(".story-more-trigger").click(function(){
        $("html").addClass("stuck")
        $("#story-more").addClass("active")
    })
    
    //generic modal closing
    $(".modal-close").click(function(){
        $("html").removeClass("stuck")
        $(".coffee-modal.active").removeClass("active")
    })

    //showing and hiding brew guides for espresso/filter and english/spanish
    $(".guides .lang-selector button").click(function(){
        $(".lang-selector button.active").removeClass("active")
        $(this).addClass("active")
        brew_video_display_check()
    })
    $(".guides .guide-selector button").click(function(){
        $(".guide-selector button.active").removeClass("active")
        $(this).addClass("active")
        brew_video_display_check()
    })

    //addon products
    $(".add-addon").click(function(){
        var variant = parseInt($(this).attr("data-variant-id"))
        var that = $(this)
        that.html("Going...")
        CartJS.addItem(variant,1, {}, {
            "success":function(line_item){
                that.html("Done!")
                show_cart_confirm(line_item)
                },
            "error":function(){
                that.html("Error :(")
            }
        });

    })

    function brew_video_display_check(){
        var lang = $(".lang-selector button.active").attr("data-lang")
        var guide = $(".guide-selector button.active").attr("data-guide")
        
        $(".guide-body.active").removeClass("active")
        $(`.guide-body[data-lang='${lang}'][data-guide='${guide}']`).addClass("active")
    }
}




const currentFrame = index => (
        `https://static.onyxcontent.com/provisions-frames/${window.anim_handle}/${window.anim_handle}_${(index).toString().padStart(4, '0')}.webp`
    );

function setup_anim_canvas(){

    window.canvas = document.getElementById("box-canvas");
    window.context = canvas.getContext("2d");
    window.canvas_w = 0
    window.canvas_h = 0

    fix_dpi(canvas)

        
    window.addEventListener("resize", function(){
        fix_dpi(canvas)
        render_canvas()
    });

    var frameCount = 165;
    

    window.images = []
    window.boxframes = {
        frame: 45
    };

    for (let i = 0; i < frameCount; i++) {
        const img = new Image();
        images.push(img);
    }


    for (var j in images){
        images[j].src = currentFrame(parseInt(j) + 1);
    }
    
    loadAllImages(images).then(() => {
        console.log("all animation frames loaded")
        window.intro_loaded = true
        intro_animation();

        $("main").addClass("spin-ready")
        
    }).catch(error => {
        console.error(error);
    });

    





    setup_scrubber()

}



function fix_dpi(canvas) {

        let parentWidth = canvas.parentElement.offsetWidth;
        let parentHeight = canvas.parentElement.offsetHeight;
        
        let ctx = canvas.getContext('2d');
        let dpr = window.devicePixelRatio || 1;
        let bsr = ctx.webkitBackingStorePixelRatio ||
                    ctx.mozBackingStorePixelRatio ||
                    ctx.msBackingStorePixelRatio ||
                    ctx.oBackingStorePixelRatio ||
                    ctx.backingStorePixelRatio || 1;

        let ratio = dpr / bsr;


        canvas.style.width = parentWidth + 'px'; // Set canvas style width to 100% of parent width
        canvas.style.height = parentHeight + 'px';
        canvas.width = parentWidth * ratio; // Adjust canvas element width for high DPI
        canvas.height = parentHeight * ratio; // Adjust canvas element height similarly if necessary
        ctx.scale(ratio, ratio); // Scale the context to counteract the increase in physical size
                                    // to keep drawings at intended size

        window.canvas_w = parentWidth
        window.canvas_h = parentHeight

        window.context = ctx
}


function render_canvas() {

    //console.log("rendering frame at index: " + boxframes.frame)
    window.context.clearRect(0, 0, window.canvas.width, window.canvas.height);
    window.context.drawImage(images[boxframes.frame], 0, 0, window.canvas_w, window.canvas_h); 
}


function loadAllImages(imageElements) {

    // Create a promise for each image load
    let promises = Array.from(imageElements).map(img => new Promise((resolve, reject) => {
        // If the image is already loaded
        if (!(img instanceof HTMLImageElement)) resolve()

        if (img.complete && img.naturalHeight !== 0) {
            resolve();
        } else {
            // Set up load and error event listeners
            img.onload = () => resolve();
            img.onerror = () => reject(new Error(`Failed to load image at ${img.src}`));
        }
    }));

    // Use Promise.all to wait for all promises to resolve
    return Promise.all(promises);
}


window.box_anime = null
window.last_intro_frame = 0

function video_stage_0(){
    if (window.anim_handle == false)
        return
    

    if (window.box_anime)
        window.box_anime.pause()

    window.box_anime = anime({
        targets: window.boxframes,
        frame: 0,
        duration:1000,
        easing: 'easeInOutQuad',
        round: 1,
        update: function() {
            render_canvas()
        }
    });
    //playVideoFrameByFrame(window.main_video, video_frame_stage_0)
}

function video_stage_1(){

    if (window.anim_handle == false)
        return


    if (window.box_anime)
        window.box_anime.pause()

    

   
    //animate back to center (from left)
    if (window.boxframes == 44){
        render_canvas()
        $("main").addClass("intro-played")
        return
    }
    else if (window.boxframes.frame < 106){
        window.box_anime = anime({
            targets: window.boxframes,
            frame: 44,
            duration:1000,
            easing: 'linear',
            round: 1,
            update: function() {
                
                if (window.last_intro_frame == window.boxframes.frame) return

                window.last_intro_frame = window.boxframes.frame

                render_canvas()
            },
            complete: function(){
                $("main").addClass("intro-played")
            }
        });
    }
    else { //animate back to center (from right)
        window.box_anime = anime({
            targets: window.boxframes,
            frame: 108,
            duration:1000,
            easing: 'linear',
            round: 1,
            update: function() {
                render_canvas()
            },
            complete: function(){
                $("main").addClass("intro-played")
                $(".box-video").addClass("clipping")
            }
        });
    }
    
    //playVideoFrameByFrame(window.main_video, video_frame_stage_1)
}
function video_stage_2(){

    console.log("video stage 2")
    
    if (window.anim_handle == false)
        return

    if (window.loaded_360 == false){
        return
    }

    if (window.box_anime)
        window.box_anime.pause()
   
    if (window.boxframes.frame >= 108) {
        window.box_anime = anime({
            targets: window.boxframes,
            frame: 164,
            duration:1000,
            easing: 'easeOutQuad',
            round: 1,
            update: function() {
                render_canvas()
            }
        });
    }
    else {
        //this is hard because sometimes the transition frames won't be exactly sequential
        window.box_anime = anime({
            targets: window.boxframes,
            frame: 80,
            duration:1000,
            easing: 'easeOutQuad',
            round: 1,
            update: function() {
                render_canvas()
            }
        });
    }
        
    

    
}

function intro_animation(){

    if (window.anim_handle == false){
        return
    }
        
    window.boxframes.frame = 0
    render_canvas()

    $("main").addClass("stage-1")
    video_stage_1()


    
}


function setup_scrubber() {


    var seekProgressEl = document.querySelector('#slider-input');

    if (!seekProgressEl) return


    //move the arrow up and down a little to make it seem
    //like its part of the circle track



    //when the slider changes value, scrub the anime
    seekProgressEl.oninput = function() {


        var progress = parseInt(seekProgressEl.value)
        //console.log(progress)

        if (progress >= 51){
            
            //go from frame 156 to 107

           var desired_frame = 164 - (progress - 51);
            window.boxframes.frame = desired_frame
            render_canvas()
        }
        else if (progress <= 49){

            //go from frame 46 to 100

            var fraction = (49 - progress) / 49; // goes from 0 to 1 as progress goes 49 -> 0
            var desired_frame = 46 + fraction * (100 - 46); 
            window.boxframes.frame = Math.round(desired_frame);
            render_canvas()
        }
        else {
            window.boxframes.frame = 46;
            render_canvas()
        }

    };
}




function setup_feat_prod_swiper() {

    var feat_prod_swipers = document.querySelectorAll(".feat-prod-slider .swiper")
    for (var swip of feat_prod_swipers){
        const swiper = new Swiper(swip, {
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 20,
            // observer: true, 
            // observeParents: true,
            mousewheel: true,
            // And if we need scrollbar
            scrollbar: {
                draggable: true,
                el: '.swiper-scrollbar',
            },
        });
    }

}


function setup_recipe_swiper() {

    var feat_prod_swipers = document.querySelectorAll(".recipes.swiper")
    for (var swip of feat_prod_swipers){
        const swiper = new Swiper(swip, {
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            slidesPerView: 1.1,
            spaceBetween: 10,
            // observer: true, 
            // observeParents: true,
            mousewheel: false,
            // And if we need scrollbar
            breakpoints: {
                800: {
                    slidesPerView: 1.5,
                    spaceBetween: 20,
                }
            },
            scrollbar: {
                draggable: true,
                el: '.swiper-scrollbar',
            },
        });
    }

}

function setup_mobile_stats_swiper() {

    window.all_m_stats = $(".mobile-stats-slider .stat-m-icon")
    var circle_radius = 140; // what are the units here??

    //this whole thing is a shit-show. 
    //Changing the slides_per_view breaks the layout
    //circle_radius means nothing, and is actually inversely proportional to the actual circle size

    var slides_per_view = 7
    var space_between = 0
    var total_slides = 8.0
    //theres a weird relationship between swiper progress and which slides are visible
    var chunk_size = 1.0 / (total_slides-1) //minus 1 because the slides are centered? This is right.
    var chunk_window_size = slides_per_view * chunk_size + chunk_size
    var baseline_to_clear = Math.ceil(slides_per_view/2.0)
    var additional = (slides_per_view % 1)/2.0

    function mapValue(x) {
        return 0;
        // if (x > 0.70)
        //     return ((x - 0.7) / (1 - 0.7)) * 200;
        // else if (x < 0.3)
        //     return ((0.3 - x) / 0.3) * 200;
        // else return 0;
    }

    const swiper = new Swiper('.mobile-stats-slider .swiper', {
        // Optional parameters
        direction: 'horizontal',
        loop: false,
        slidesPerView: slides_per_view,
        initialSlide: 0,
        //loop:true,
        speed:200,
        slideToClickedSlide: true,
        centeredSlides: true,
        spaceBetween: space_between,
        // observer: true, 
        // observeParents: true,
        on: {
            slideChange: function(swip){
                var active_slide = swip.slides[swip.activeIndex]

                var stat_id = $(active_slide).attr("data-stat-id")
                $(".a-stat-desc").removeClass("in")

                if (stat_id == "abstract"){
                    $(".a-stat-desc.blurb").removeClass("out")
                }
                else if (stat_id != "" && stat_id){
                    //console.log("adding out??")
                    //console.log(stat_id)
                    $(".a-stat-desc.blurb").addClass("out")
                }
                
                var stat_desc = $(".a-stat-desc[data-stat-id='"+stat_id+"']")
                stat_desc.addClass("in")


                //swap out the inner text
            },
            touchStart: function(){
                $(".mobile-stats-slider").addClass("touching")
            },
            touchEnd: function(){
                $(".mobile-stats-slider").removeClass("touching")
            },
            progress: function(swip, progress){
                for (var i in window.all_m_stats){
                    let el = window.all_m_stats[i]
                    
                    var start_chunk = (i-baseline_to_clear - additional) * chunk_size
                    var end_chunk = start_chunk + chunk_window_size

                    
                    if (progress > start_chunk && progress < end_chunk){
                        //animating this specific slide!
                        var percent_through = (progress-start_chunk) / (end_chunk-start_chunk) //this is WRONG
                        

                        var offset = mapValue(percent_through)
                        if (i == 0) {
                            console.log(percent_through)
                            console.log(offset)
                        }
                            
                       
                        el.style.transform = `translate3d(0px, -${offset}px, 0)`;
                        
                    }


                }

            },
        },
        
        // And if we need scrollbar
        scrollbar: {
            draggable: true,
            el: '.swiper-scrollbar',
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
}




function setup_stat_hovers(){

    //we want the stat hovers to be relatively sticky

    $(".stage").hover(function(){
        //nothing?
        $(".stage").addClass("hovered")
    }, function(){

        if (window.innerWidth < 800){
            return
        }

        $(".stage").removeClass("hovered")
        $(".stage").removeClass("darkened")
        $(".a-stat-desc.blurb").removeClass("out")
        $(".a-stat-desc").removeClass("in")
        $(".a-stat.active").removeClass("active")
        $(".stat-vids img.in").removeClass("in")
    })



    $(".stat-text").hover(function(){
        //hover in!

        var stat_id = $(this).parent().attr("data-stat-id")
        
        $(".a-stat-desc.blurb").removeClass("out")
        $(".a-stat-desc").removeClass("in")
        $(".a-stat.active").removeClass("active")
        $(".stat-vids img.in").removeClass("in")
        
        

        $(this).parent().addClass("active")
        
        if (stat_id != "abstract"){
            $(".stage").addClass("hovered")
            $(".a-stat-desc.blurb").addClass("out")
            $(".stage").addClass("darkened")

            var stat_desc = $(".a-stat-desc[data-stat-id='"+stat_id+"']")
            stat_desc.addClass("in")

            var stat_vid = $(".stat-vids img[data-stat-id='"+stat_id+"']")
            stat_vid.addClass("in")
        }
        else {
            $(".stage").removeClass("darkened")
        }

        
        
        
    }, function(){
        //hover out!

        

        if (!$(".stage").hasClass("hovered")){
            $(".a-stat-desc.blurb").removeClass("out")
            $(".a-stat-desc").removeClass("in")
            $(".a-stat.active").removeClass("active")
            $(".stage").removeClass("darkened")
        }

        
    })


}


function setup_scrollties(){

    window.container_target = document.querySelector("main")
    window.body_target = document.querySelector("body")

    
    window.title_spacer = document.querySelector(".test-before")
    window.intro_spacer = document.querySelector("#hero-spacer")
    window.story_spacer = document.querySelector("#story-spacer")
    window.guides_spacer = document.querySelector(".guides")
    

    //hero scrollties
    ;(function(){

        

        //sometimes this can fire before the intro animation has completed. 
        //This has extra stuff in it to make sure that its still ok to fire despite the animation not being done
        let to_stage_2 = new Scroller({
            id:"stage-2",
            container:title_spacer,
            window_offset: 0.0,
            el_start: 0.2,
            el_end: 0.21,
            targets:[body_target],
            classes:["stage-2"],
            stick_class: true,
            markers: true,
            onstart: function(){

                //(just in case)
                $("main").addClass("stage-1")
                $(".box-video").addClass("clipping")

                setTimeout(function(){
                    $("#slider-input").val(50).css("transform","translateY(0)")//reset the input
                },300)
                

                video_stage_2()

            },
            onunstart: function(){
                video_stage_1()



            }
        })
        scrolltied.add(to_stage_2)



      
        if (window.box_set) return

      
        //radial circle goes upwards constanly
        let radial_anime = anime({
            targets: ".hero-intro .radial",
            // opacity: 0,
            translateY: ["50vh", "-50vh"],
            autoplay: false,
            duration: 100,
            easing: 'easeInQuad'
        });
        let radial_tied = new Scroller({
            id:"radial-veritcal",
            container:intro_spacer,
            window_offset: 0,
            el_start: 0,
            el_end:0.9,
            anime: radial_anime,
            markers: true,
        })
        scrolltied.add(radial_tied)





        //stats goes upwards constanly
        let blurb_anime = anime({
            targets: ".stats-descs",
            // opacity: 0,
            translateY: ["10px", "-50px"],
            autoplay: false,
            duration: 100,
            easing: 'linear'
        });
        let blurb_tied = new Scroller({
            id:"blurb-veritcal",
            container:intro_spacer,
            window_offset: 0,
            el_start: -0.2,
            el_end:0.9,
            anime: blurb_anime,
            markers: true,
        })
        scrolltied.add(blurb_tied)




    })();



    //box set "parents" don't get the rest of the data on-page
    if (window.box_set == true) return





    //story scrollties
    ;(function(){


        // add stage-4 class (the stats and hero are totally gone)
        // this mainly just changes colors around for late-stage ATC states
        let to_stage_3 = new Scroller({
            id:"stage-3-trigger",
            container:story_spacer,
            window_offset:1,
            el_start: 0.0,
            el_end: 0.01,
            targets:[body_target],
            classes:["stage-3","light-shell"],
            stick_class: true,
            markers: true
        })
        scrolltied.add(to_stage_3)



       


        //blinds text for story
        scrolltied.add(new Scroller({
            id: 'story-title-blinds',
            container:story_spacer,
            targets: [document.querySelector(".story-preview h2")],
            window_offset: 1,
            el_start: 0,
            el_end:0.1,
            classes: ['visible'],
            stick_class: true,
            markers: true
        }))

        


        //blinds text for collab
        var collab_title_target = document.querySelector(".collab-addons h2")
        if (collab_title_target){
            scrolltied.add(new Scroller({
                id: 'collab-title-blinds',
                container:document.querySelector(".collab-addons"),
                targets: [collab_title_target],
                window_offset: 1,
                el_start: 0.2,
                el_end:0.6,
                classes: ['visible'],
                stick_class: true,
                markers: true
            }))
        }
        
    

        
        


        //story text goes upwards
        let story_text_vert_anime = anime({
            targets: ".story-preview",
            // opacity: 0,
            translateY: [
                { value: "-50%", duration: 100, delay: 0 }
            ],
            autoplay: false,
            duration: 100,
            easing: 'easeInOutQuad'
        });
        let story_text_vert = new Scroller({
            id:"story-veritcal",
            container:story_spacer,
            window_offset: 1,
            el_start: 0.3,
            el_end:1.2,
            anime: story_text_vert_anime,
            markers: true,
        })
        scrolltied.add(story_text_vert)


        //story text fades out
        let story_text_out_anime = anime({
            targets: ".story-preview",
            opacity: 0,
            autoplay: false,
            duration: 100,
            easing: 'easeInOutQuad'
        });
        let story_text_out = new Scroller({
            id:"story-fadeout",
            container:story_spacer,
            window_offset: 0.5,
            el_start: 0.5,
            el_end:0.8,
            anime: story_text_out_anime,
            markers: true,
        })
        scrolltied.add(story_text_out)


        return

    })();




    //brew guides
    (function(){


        //blinds text for story
        scrolltied.add(new Scroller({
            id: 'stage-4',
            container:story_spacer,
            targets: [document.querySelector("main")],
            window_offset: 1,
            el_start: 1,
            el_end:1.1,
            classes: ['stage-4'],
            stick_class: true,
            markers: true
        }))


        scrolltied.add(new Scroller({
            id:"brew-darken-vids",
            container:guides_spacer,
            el_start: -0.2,
            window_offset: 0.5,
            el_end:0.3,
            anime: anime({
                targets: ".story-bg .color",
                opacity: [0.45,0.9],
                autoplay: false,
                duration: 100,
                easing: 'easeInOutQuad'
            }),
            markers: true,
        }))



        scrolltied.add(new Scroller({
            id: 'brew-title-anim',
            container:document.querySelector('.guides'),
            targets: [document.querySelector(".guide-header h2")],
            window_offset: 1,
            el_start: 0.2,
            el_end: 0.21,
            classes: ['visible'],
            stick_class: true,
            markers: true
        }))

    })();







    scrolltied.start()
    scrolltied.update()


    return







}

